import { UserTextParagraph } from '../common';
import { FormLabel } from './FormLabel';
import { HorizontalFormGroupRead } from './horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from './InputContainer';

interface ReadCustomControlDataProps {
    label: string;
    value: string | null | undefined;
}
export function ReadCustomControlData(props: ReadCustomControlDataProps) {
    const { label, value } = props;

    if (!value) {
        return null;
    }

    return (
        <HorizontalFormGroupRead>
            <FormLabel>{label}</FormLabel>
            <InputContainer>
                <UserTextParagraph>{value}</UserTextParagraph>
            </InputContainer>
        </HorizontalFormGroupRead>
    );
}
